import {
  fetchClient
} from "./chunk-64N4INLD.mjs";
import {
  __async
} from "./chunk-RGHW4PYM.mjs";

// src/core/wbk/newsletter/subscribe.ts
import { Exception } from "@wbk/logger";
var subscribe = (props) => __async(null, null, function* () {
  var _a, _b, _c;
  try {
    const data = yield fetchClient({
      url: "/subscribe-to-newsletter",
      options: {
        method: "POST",
        body: JSON.stringify(props)
      }
    });
    if (((_a = data.status) == null ? void 0 : _a.toLowerCase()) !== "success") {
      const msg = typeof data.message === "string" ? data.message : (_c = (_b = data == null ? void 0 : data.error) == null ? void 0 : _b.email) == null ? void 0 : _c[0];
      throw new Error(msg || "Something went wrong");
    }
    return data.data;
  } catch (error) {
    throw new Exception({
      error,
      name: "subscribeException"
    });
  }
});

export {
  subscribe
};
//# sourceMappingURL=chunk-W6AJTTKQ.mjs.map